import { render, staticRenderFns } from "./comment-dialog.vue?vue&type=template&id=7d8329d3&scoped=true&"
import script from "./comment-dialog.vue?vue&type=script&lang=js&"
export * from "./comment-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8329d3",
  null
  
)

export default component.exports